import { render, staticRenderFns } from "./ReviewDomainDetail.vue?vue&type=template&id=207a8ff2&scoped=true"
import script from "./ReviewDomainDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDomainDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewDomainDetail.vue?vue&type=style&index=0&id=207a8ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a8ff2",
  null
  
)

export default component.exports